// @flow
import React from 'react'
import { ItemsWrapper, Item } from './styles'

type Props = { products: Array<Object> }

const Cart = (props: Props) => (
  <ItemsWrapper>
    {props.products.map((product, index) => (
      <Item key={product.id}>
        <img src={product.medias.large} alt={product.name} />
      </Item>
    ))}
  </ItemsWrapper>
)

export default Cart
